// Queries the vehicle info involving TVL to get the status

import { Vehicle, VehicleQueryParams } from "../types/vehicle";
import { createDataContext } from "./Context";

const parseVehicleResponse = (response: Vehicle[]): Vehicle[] => {
    return Array.isArray(response) ? response : [];
}

export const { useDataContext: useVehicleContext, DataProvider: VehicleProvider } = createDataContext<Vehicle, VehicleQueryParams>(
    'tripQueryAPI',
    '/users/v1/getvehicleinfotvl',
    parseVehicleResponse
)
